import React, { FC, useState, useMemo } from "react";
import { MatterAutoComplete, MatterValue } from "@design-system";
import { useTextFilteredMattersLazy } from "../../hooks/matters";

interface Props {
  value?: number[];
  onChange?: (value: number[]) => void;
  requiredMatters?: MatterValue[];
}

export const MultiSelectMatterContainer: FC<Props> = ({
  value = [],
  onChange,
  requiredMatters: propsRequiredMatters = [],
}) => {
  const [requiredMatters, setRequiredMatters] = useState(propsRequiredMatters);

  const displayValue = useMemo(() => {
    return value
      .map((id: any) => requiredMatters.find((matter: any) => matter.id === id))
      .filter((matter): matter is MatterValue => matter !== undefined);
  }, [value, requiredMatters]);

  const matterFilterData = useTextFilteredMattersLazy(10);

  return (
    <MatterAutoComplete
      onChangeMultipleMatters={(matters) => {
        const newValue = matters.map((matter: any) => matter.id);
        const newRequiredMatters = [...requiredMatters, ...matters];
        setRequiredMatters(newRequiredMatters);
        onChange && onChange(newValue || []);
      }}
      matterFilterData={{
        ...matterFilterData,
        matters: [...matterFilterData.matters, ...requiredMatters],
      }}
      bordered
      value={displayValue}
      defaultValue={displayValue}
      mode="multiple"
    />
  );
};
